import { render, staticRenderFns } from "./EditItemList.vue?vue&type=template&id=054c0b87&scoped=true&"
import script from "./EditItemList.vue?vue&type=script&lang=js&"
export * from "./EditItemList.vue?vue&type=script&lang=js&"
import style0 from "./EditItemList.vue?vue&type=style&index=0&id=054c0b87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c0b87",
  null
  
)

export default component.exports